



















































import { Vue, Component, Watch } from "vue-property-decorator";
import { UserService } from "src/services";
import { IAppModel, IMenuModel, IUserLoginInfoModel } from "src/model";
import router from '../../router';

@Component
export default class Shop extends Vue
{
    
    /**
     * 创建店铺
     * @protected
     * @returns UserService
     */
    protected onAddShop(): void
    {
        this.$router.push({name:'industryType'})
    }
    /**
     * 获取用户服务
     * @private
     * @return UserService
     */
    private _userService: UserService;

    /**
     * 机构列表
     * @protected
     * @returns 
     */
    protected dataList: Array<any> = [];

    /**
     * 店铺名称
     * @protected
     * @returns 
     */
    protected shopName: string = "";

    /**
     * 剩余可创建店铺
     * @protected
     * @returns 
     */
    protected remainingNum: number = 0;

    /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get userService(): UserService
    {
        if(!this._userService)
        {
            this._userService = this.$serviceProvier.resolve<UserService>(UserService);
        }

        return this._userService;
    }

    /**
     * 用户信息
     * @protected
     * @type {any}
     */
    protected get userInfo(): any {

        return this.$store.getters["global/userInfo"]
    }

    /**
     * 获取用户信息
     * @private
     * @return Promise<void>
     */
    private async getLoginInfo(): Promise<void>
    {
        try
        {
            let {content: result} = await this.userService.getLoginInfo();
            if(result.data)
            {
                // 存储登入所有信息
                this.$store.dispatch("user/setProfile", result.data);
                this.handleMenu(result.data);
            }
        } 
        catch(err)
        {
            
            this.$message.error({
                duration: 3,
                content: JSON.stringify(err)
            })
        }
    }

    /**
     * 处理菜单数据
     * @private
     * @return Promise<void>
     */
    private async handleMenu(profile: IUserLoginInfoModel): Promise<void>
    {
        if (profile.menus.length === 0) {
            this.$message.warning("您无菜单权限,请联系管理员");
            return;
        }
        localStorage.removeItem("app_menu");
        // 拿菜单信息
        let app_menu = localStorage.getItem("app_menu");
        let antDesignmenus
        if (!app_menu)
        {
            const applocation: Array<any> = [];
            // 应用信息
            profile.apps.forEach((item: IAppModel) =>
            {
                const apps:{
                    code: string,
                    name: string,
                    active: boolean,
                    menu: Array<IMenuModel>
                } = { code: '', name: '', active: true, menu: [] }
                if (item.active) {
                    apps.code = item.code
                    apps.name = item.name
                    apps.active = item.active
                    apps.menu = profile.menus
                    antDesignmenus = profile.menus
                } else {
                    apps.code = item.code
                    apps.name = item.name
                    apps.active = item.active
                    apps.menu = []
                }
                applocation.push(apps)
            })
            // 存储菜单缓存信息
            localStorage.setItem("app_menu", JSON.stringify(applocation))
        }
        else
        {
            // 取缓存数据
            antDesignmenus = app_menu && JSON.parse(app_menu)&&JSON.parse(app_menu)[0] && JSON.parse(app_menu)[0].menu || [];
        }
        
        this.$store.dispatch('global/generateRoutes', antDesignmenus).then(() =>
        {
            // 动态添加可访问路由表
            router.addRoutes(this.$store.getters["global/menuData"])
            this.$router.push({ name: 'console' });
            
        })
    }

    /**
     * 组件创建钩子。
     * @protected
     * @returns void
     */
    protected created(): void
    {
        this.getMyTenants();
        // 清除缓存店铺id
        localStorage.removeItem('tenantId');
    }

    /**
   * 注销登录
   * @protected
   * @return void
   */
  protected async logout(): Promise<void> {
    try {
      await this.userService.logout();
    } catch (err) {
      this.$message.error({
        duration: 3,
        content: err || "服务器错误",
      });
    }
  }

    /**
     * 退出登录
     * @protected
     * @returns void
     */
    protected loginOut(): void
    {
        this.$confirm({
      title: "提示",
      content: "是否确定注销登录?",
      okText: "确定",
      cancelText: "取消",
      onOk: async () => {
        return await this.logout()
          .then(() => {
            setTimeout(() => {
                localStorage.clear();
                this.$router.push("/")
            }, 20);
          })
          .catch(() => {
            this.$message.error("注销失败");
          });
      },
      onCancel() {},
    });
    }

    /**
     * 跳转店铺。
     * @protected
     * @returns void
     */
    protected onGoShop(item: any): void
    {
        this.$store.commit("global/SET_TENANT_ID", item.id);
        this.getLoginInfo();
    }
    /**
     * 个人设置
     * @protected
     * @returns void
     */
    protected accSet(): void
    {
        this.$router.push({name: "accountSettings"})
    }

    /**
     * 获取店铺列表
     * @protected
     * @returns 
     */
    protected async getMyTenants(): Promise<void>
    {
        try
        {
            let {content: result} = await this.userService.getMyTenants();
            this.dataList=result.data.tenants;
            this.remainingNum = result.data.remainingNum;
        }
        catch(err)
        {
            this.$message.error({
                duration: 3,
                content: JSON.stringify(err)
            })
        }
    }
    
}
